import { DeviceInfo } from 'qunar-react-native';

export default !!(
    DeviceInfo.platform.toLocaleLowerCase() === 'android' && Number(DeviceInfo.osVersion) < 23
);
